module.exports = "A callout is an anchored tip that can be used to teach people or guide them through the app without blocking them.\n"